/* unplugin-vue-components disabled */import { render } from "./icon-button.vue?vue&type=template&id=20bb3817&scoped=true"
import script from "./icon-button.vue?vue&type=script&lang=js"
export * from "./icon-button.vue?vue&type=script&lang=js"

import "./icon-button.vue?vue&type=style&index=0&id=20bb3817&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bb3817"]])

export default __exports__